import React, { useState, useEffect } from "react";
import { isValidEmail, isValidMobile } from "../../../utils/HelperFunction";
import httpRequest from "../../../utils/Http";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ONLY_RM_ASM_ACTION_PERMISSION } from "../../../constant/action_permission";

export default function SFContactPerson({ sfdetails, SetSfDetails, roleId }) {
  const [formData, setFormData] = useState({ sf_id: sfdetails.id });
  const [isSubmit, setSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [pocFormData, setPOCFormData] = useState({ sf_id: sfdetails.id });
  const [pocFormErros, setPocErrors] = useState({});
  const [ispSubmit, setpSubmit] = useState(false);

  const submitOwnerDetails = (e) => {
    e.preventDefault();

    setSubmit(false);
    setFormErrors(validateOwnerFrom(formData));
    setSubmit(true);
  };

  const submitPocDetails = (e) => {
    e.preventDefault();
    setpSubmit(false);
    setPocErrors(validatePocFrom(pocFormData));
    setpSubmit(true);
  };

  const validateOwnerFrom = (value) => {
    let errors = {};
    if (!value.name) {
      errors.name = "Name is Required";
    }
    if (!value.mobile_number) {
      errors.mobile_number = "Mobile Number is Required";
    } else if (!isValidMobile(value.mobile_number)) {
      errors.mobile_number = "Mobile Number is not valid";
    }

    if (!value.email) {
      errors.email = "Email ID is Required";
    } else if (!isValidEmail(value.email)) {
      errors.email = "Enter Valid Email ID";
    }
    return errors;
  };

  const validatePocFrom = (value) => {
    let errors = {};
    if (!value.name) {
      errors.name = "Name is Required";
    }
    if (!value.mobile_number) {
      errors.mobile_number = "Mobile Number is Required";
    } else if (!isValidMobile(value.mobile_number)) {
      errors.mobile_number = "Mobile Number is not valid";
    }

    if (!value.email) {
      errors.email = "Email ID is Required";
    } else if (!isValidEmail(value.email)) {
      errors.email = "Enter Valid Email ID";
    }
    return errors;
  };

  useEffect(() => {
    (async () => {
      if (sfdetails.id) {
        setPOCFormData({
          ...pocFormData,
          sf_id: sfdetails.id,
          name: sfdetails.poc_details?.name,
          mobile_number: sfdetails.poc_details?.mobile_number,
          email: sfdetails.poc_details?.email,
          poc_id: sfdetails.poc_id,
        });

        setFormData({
          ...formData,
          sf_id: sfdetails.id,
          name: sfdetails.owner_details?.name,
          mobile_number: sfdetails.owner_details?.mobile_number,
          email: sfdetails.owner_details?.email,
          owner_id: sfdetails.owner_id,
        });
      }
    })();
  }, [sfdetails]);

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest(
          "updatesfownerdetails",
          formData,
          "POST",
        );

        if (data.status === true && data.message) {
          toast.success(data.message);
          SetSfDetails(data.data);
        } else {
          toast.error(data.message);
        }
        setpSubmit(false);
      }
    })();
  }, [isSubmit, formErrors]);

  useEffect(() => {
    (async () => {
      if (Object.keys(pocFormErros).length === 0 && ispSubmit) {
        const data = await httpRequest(
          "updatesfpocdetails",
          pocFormData,
          "POST",
        );
        if (data.status === true && data.message) {
          toast.success(data.message);
          SetSfDetails(data.data);
        } else {
          toast.error(data.message);
        }
        setpSubmit(false);
      }
    })();
  }, [ispSubmit, pocFormErros]);

  return (
    <>
      <section className="content sf-contact-person-section-wrap">
        <div className="container-fluid">
          <form
            id="updateContactPerson"
            onSubmit={submitOwnerDetails}
            className="company-basic-form sf-contact-person-form"
          >
            <div className="form-section">
              <div className="section-header">
                <h5>Owner Details</h5>
                <div className="section-divider"></div>
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label className="field-label">
                    Name <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.name ? "input-error" : ""}`}
                    id="owner_name"
                    placeholder="Enter Name"
                    defaultValue={formData.name}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      });
                    }}
                  />
                  {formErrors.name && (
                    <span className="error-message">{formErrors.name}</span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Mobile Number <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.mobile_number ? "input-error" : ""}`}
                    id="mobile_number"
                    placeholder="Enter Mobile Number"
                    defaultValue={formData.mobile_number}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        mobile_number: e.target.value,
                      });
                    }}
                  />
                  {formErrors.mobile_number && (
                    <span className="error-message">
                      {formErrors.mobile_number}
                    </span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Email ID <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${formErrors.email ? "input-error" : ""}`}
                    id="email_id"
                    placeholder="Enter Email ID"
                    defaultValue={formData.email}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        email: e.target.value,
                      });
                    }}
                  />
                  {formErrors.email && (
                    <span className="error-message">{formErrors.email}</span>
                  )}
                </div>
              </div>

              {ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && (
                <div className="form-actions">
                  <button type="submit" className="btn-submit">
                    <i className="fas fa-save"></i> Save Owner
                  </button>
                </div>
              )}
            </div>
          </form>

          <form
            id="updatePOC"
            onSubmit={submitPocDetails}
            className="company-basic-form sf-contact-person-form"
          >
            <div className="form-section">
              <div className="section-header">
                <h5>POC Details</h5>
                <div className="section-divider"></div>
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label className="field-label">
                    Name <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${pocFormErros.name ? "input-error" : ""}`}
                    id="poc_name"
                    placeholder="Enter Name"
                    defaultValue={pocFormData.name}
                    onChange={(e) => {
                      setPOCFormData({
                        ...pocFormData,
                        name: e.target.value,
                      });
                    }}
                  />
                  {pocFormErros.name && (
                    <span className="error-message">{pocFormErros.name}</span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Mobile Number <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${pocFormErros.mobile_number ? "input-error" : ""}`}
                    id="poc_mobile_number"
                    placeholder="Enter Mobile Number"
                    defaultValue={pocFormData.mobile_number}
                    onChange={(e) => {
                      setPOCFormData({
                        ...pocFormData,
                        mobile_number: e.target.value,
                      });
                    }}
                  />
                  {pocFormErros.mobile_number && (
                    <span className="error-message">
                      {pocFormErros.mobile_number}
                    </span>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label">
                    Email ID <span className="required-mark">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-input ${pocFormErros.email ? "input-error" : ""}`}
                    id="poc_email_id"
                    placeholder="Enter Email ID"
                    defaultValue={pocFormData.email}
                    onChange={(e) => {
                      setPOCFormData({
                        ...pocFormData,
                        email: e.target.value,
                      });
                    }}
                  />
                  {pocFormErros.email && (
                    <span className="error-message">{pocFormErros.email}</span>
                  )}
                </div>
              </div>

              {ONLY_RM_ASM_ACTION_PERMISSION.includes(roleId) && (
                <div className="form-actions">
                  <button type="submit" className="btn-submit">
                    <i className="fas fa-save"></i> Save POC
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </section>
    </>
  );
}
